<section class="shop-gear-section py-5 text-white">
  <div class="container-fluid py-4">
    <!-- Header -->
    <div class="text-center mb-5">
      <h2 class="section-title hf text-uppercase text-white f120">SHOP XDGE GEAR</h2>
    </div>

    <!-- Product Grid -->
    <div class="row g-4 justify-content-center p-lg-0 px-4 px-md-5" *ngIf="!loading && storeProducts.length; else loadingTemplate">
      <div *ngFor="let product of storeProducts; trackBy: trackByLevelTag" class="col-12 col-sm-6 col-md-6 col-lg-3 d-flex">
        <div
          class="product-card w-100 p-4 rounded-4 d-flex flex-column align-items-center justify-content-between text-center position-relative handPointer transition-all"
          [class.active-card]="product.isActive"
          (click)="buyProduct(product, $event)"
          (mouseenter)="onProductHover(product)"
          (mouseleave)="onProductLeave($event)"
        >
          <!-- Active Pill ("BUY NOW") -->
          <div *ngIf="product.isActive" class="hero-btn red text-uppercase f16">BUY NOW</div>

          <!-- Cap Image Container -->
          <div class="image-container d-flex align-items-center justify-content-center w-100 flex-grow-1">
            <div class="product-carousel w-100" [class.single-image]="!hasMultipleImages(product)">
              <button
                *ngIf="hasMultipleImages(product)"
                class="carousel-nav prev"
                type="button"
                [attr.aria-label]="'Previous image'"
                (click)="onPrevImage(product, $event)"
              >
                <span>&lsaquo;</span>
              </button>

              <div class="carousel-image d-flex align-items-center justify-content-center">
                <img [src]="getActiveImage(product)" [alt]="product.title" class="product-image img-fluid" loading="lazy" />
              </div>

              <button
                *ngIf="hasMultipleImages(product)"
                class="carousel-nav next"
                type="button"
                [attr.aria-label]="'Next image'"
                (click)="onNextImage(product, $event)"
              >
                <span>&rsaquo;</span>
              </button>

              <div class="carousel-dots" *ngIf="hasMultipleImages(product)">
                <button
                  *ngFor="let _ of getProductImages(product); index as idx"
                  class="dot"
                  [class.active]="isActiveCarouselImage(product, idx)"
                  type="button"
                  [attr.aria-label]="'Go to image ' + (idx + 1)"
                  (click)="onSelectImage(product, idx, $event)"
                ></button>
              </div>
            </div>
          </div>

          <!-- Product Details -->
          <div class="details-container mt-3 w-100">
            <p class="product-price text-danger mb-1 fw-bold hf fs-5 f12">
              {{ product.price | currency: product.currencyCode || 'USD' : 'symbol' : '1.2-2' }}
            </p>
            <h4 class="product-level text-white hf text-uppercase mb-1 fs-5 f18">
              {{ product.levelLabel }}
            </h4>
            <p class="product-name text-secondary hf text-uppercase mb-0 fs-6 f18">
              {{ product.title }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #loadingTemplate>
    <div class="text-center py-5">
      <p class="text-secondary mb-0">{{ loading ? 'Loading gear...' : 'No products available at the moment.' }}</p>
    </div>
  </ng-template>
</section>
